import {
  FirstNameInput,
  LastNameInput,
  InstagramInput,
  EmailInput,
  PhoneInput,
  ImageInput,
} from "./PerformerInputs";
import type { Performer } from "@/app/_services/PerformerService";

export const PerformerForm = ({
  control,
  errors,
  defaultPerformer,
  onImageSelect,
}: {
  control: any;
  errors: any;
  defaultPerformer?: Performer | null;
  onImageSelect: (dataUrl: string | null) => void;
}) => {
  return (
    <form id="performer-form" onSubmit={(e) => e.preventDefault()}>
      <div className="grid gap-4">
        <ImageInput currentImage={defaultPerformer?.img_url} onSelect={onImageSelect} />
        <FirstNameInput control={control} errors={errors} />
        <LastNameInput control={control} errors={errors} />
        <InstagramInput control={control} errors={errors} />
        <EmailInput control={control} errors={errors} />
        <PhoneInput control={control} errors={errors} />
      </div>
    </form>
  );
};
